import tw from "tailwind-styled-components"

export const ContentContainer = tw.div`
pt-9    
pr-12
pl-12
pb-12
`